import { codetableAdministrationTranslation } from 'app/area/codetable/constants';

export enum RiskMatrixIds {
  riskMatrixType = 'riskMatrixType'
}

export enum RiskMatrixSortOrderType {
  ascending = 1,
  descending = 2
}

export const compactModeThreshold = 4;

export const riskMatrixTranslation = {
  ...codetableAdministrationTranslation,

  update_risk_matrix: 8949,
  risk_matrix_used_for: 8950,
  risk_matrix_type: 8951,
  risk_matrix_saved_successfully: 8952,
  weight: 8953,
  risk_area: 8954,
  recurrence_frequency: 8787
};

export type RiskMatrixTranslation = {
  readonly [T in keyof typeof riskMatrixTranslation]: string
};
